import { FolkInk } from '../folk-ink';
FolkInk.define();
export { FolkInk };
//# sourceMappingURL=folk-ink.js.map